import CardService from "../Shared/CardService";
/* import ImageVPN from "src/assets/images/services/vpnforex.png"; */
import ImageWeltrade from "src/assets/images/services/weltrade.png";
/* import ImageNequi from "src/assets/images/services/nequi.png"; */
import ImageDsf from "src/assets/images/services/dsfweb.png";
import ImageAcademy from "src/assets/images/services/coursetrading.png";
import ImageExchange from "src/assets/images/services/exchange.png";
import ImageP2p from "src/assets/images/services/p2p.png";
import ImageTradingChannel from "src/assets/images/services/tradingchannel.png";
import { Link } from "react-router-dom";
import { visitWhatsapp, visitWhatsappExpert } from "../Shared/Whatsapp";
/* import { BiSupport } from "react-icons/bi";
import { SiTelegram } from "react-icons/si";
import { visitWhatsapp } from "../Shared/Whatsapp";
import whatsapp from "../../assets/images/whatsapp.png"; */
import video from "src/assets/video/service.mp4";
import { UseAuth } from "src/auth/AuthContext";
const OurServices: React.FC = () => {
  const { isAuthenticated } = UseAuth();

  return (
    <div className="video-background-container">
      <div className="flex items-center justify-center lg:block">
        <div className="absolute lg:hidden text-3xl sm:text-4xl md:text-[2.5rem] py-4 sm:py-14 md:py-20 gap-2 font-bold text-white z-20 text-movile-services">
          Conoce
          <div>Nuestros</div>
          <div>Servicios</div>
        </div>
        <video
          autoPlay
          loop
          muted
          playsInline
          className="video-background z-10"
        >
          <source src={video} type="video/mp4" />
          Tu navegador no soporta el elemento de video.
        </video>
      </div>

      <div className="video-overlay"></div>

      <div className="content-overlay">
        <div className="w-full  mx-auto ">
          {/*       <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-4 py-2 w-11/12 mx-auto">
        <div className="text-center rounded-md py-8">
          <div className="flex justify-center items-center ">
            <BiSupport className="text-gray-600" size={30} />
          </div>
          <div className="font-normal text-xl mb-7">{t("telegramjoin")}</div>
          <a
            target="_blank"
            href="https://t.me/ISFcambiosadmin"
            className="border border-stone-400 text-black px-4 py-1 font-medium hover:bg-dark-green hover:text-white rounded-sm transition-none text-base"
            rel="noreferrer"
          >
            {t("enter")}
          </a>
        </div>
        <div className="text-center rounded-md py-8">
          <div className="flex justify-center items-center text-sky-500">
            <SiTelegram size={30} />
          </div>
          <div className="font-normal text-xl mb-7"> {t("forexjoin")} </div>
          <a
            target="_blank"
            href="https://t.me/KForexDeriv"
            className="border border-stone-400 text-black px-4 py-1 font-medium hover:bg-dark-green hover:text-white rounded-sm transition-none text-base"
            rel="noreferrer"
          >
            {t("enter")}
          </a>
        </div>
        <div className="text-center rounded-md py-8">
          <div className="flex justify-center items-center">
            <img src={whatsapp} className="w-8" alt="whatsapp"/>
          </div>
          <div className="font-normal text-xl mb-7 cursor-pointer">
            {t("comercialasesor")}
          </div>
          <span
            onClick={() => visitWhatsapp()}
            className="border border-stone-400 text-black px-4 py-1 font-medium hover:bg-dark-green hover:text-white rounded-sm transition-none text-base cursor-pointer"
          >
            {t("chatwithasesor")}
          </span>
        </div>
      </div> */}
          <div className="text-center hidden lg:block  mt-2  md:text-4xl font-black md:font-extrabold text-black lg:text-stone-200 py-5">
            Nuestros servicios
          </div>
          <div className="mt-2 grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-3  gap-x-8 gap-y-2 py-2 w-full px-4 md:px-0 sm:w-11/12 lg:w-8/12 mx-auto">
            <CardService
              title={"Exchange saldos digitales"}
              image={ImageExchange}
              list={
                <div className=" md:font-medium text-stone-400 text-xs">
                  Pagos seguros y rápidos con encriptación, fondos en minutos y
                  opciones con tasas competitivas.
                </div>
              }
            />

            <CardService
              title={"Academia de trading"}
              image={ImageAcademy}
              list={
                <div className=" md:font-medium text-stone-400 text-xs">
                  Mejora tu trading con análisis, gestión de riesgos y acceso a
                  recursos exclusivos.
                  <div className="relative mt-4 mb-2">
                    <Link
                      to={isAuthenticated ? "/aprender" : "/academia"}
                      className="opensans bg-red-500  hover:bg-indigo-500 text-white hover:text-white mt-1 mx-auto font-semibold w-fit px-2 py-2 rounded-md "
                      target="_blank"
                    >
                      Estudiar
                    </Link>
                  </div>
                </div>
              }
            />

            <CardService
              title={"Crear cuenta indices sintenticos"}
              image={ImageWeltrade}
              list={
                <div className=" md:font-medium text-stone-400 text-xs">
                  Bróker +17 años experiencia. Forex e Índices Sintéticos.
                  Spreads + bajos del mercado.
                  <div className="mt-4 mb-2">
                    <Link
                      to="https://es.gowt.net/ib61380"
                      target="_blank"
                      className="opensans bg-red-500  hover:bg-indigo-500 hover:text-white text-white mt-1 mx-auto font-semibold text-black w-fit  montserrat px-2 py-2 rounded-md"
                    >
                      Crear
                    </Link>
                  </div>
                </div>
              }
            />

            {/*         <CardService
          title={"VPN Privada Forex oficial"}
          image={ImageVPN}
          list={
            <ul className="text-gray-700 flex flex-col gap-4 text-sm font-normal">
              <li>
                 Protege tu identidad y datos personales de hackers y
                terceros.
              </li>
              <li> Accede a contenido restringido en tu país o región.</li>
              <li className="mb-3"> Navega sin límites y sin rastreo.</li>

             <li>
                <Link
                  to="https://vpnforex.com/"
                  target="_blank"
                  className="bg-stone-600 text-stone-100  hover:text-white mt-2 font-medium w-fit px-4 py-2 rounded-md "
                >
                  Entrar
                </Link>
              </li> 
            </ul>
          }
        /> */}

            {/*         <CardService
          title={"DERIV Recarga automática"}
          image={ImageNequi}
          list={
            <ul className="text-gray-700 flex flex-col gap-4 text-sm font-normal">
              <li> Ahora tus recargas a Deriv son instantáneas.</li>
              <li> Recarga automáticamente con nuestro bot telegram.</li>
              <li className="mb-3">
                 Funciona 24/7 , sigue los pasos y paga desde app Nequi.
              </li>
              <li>
                <Link
                  to="https://t.me/tepagoya_bot"
                  target="_blank"
                  className="bg-stone-600 text-stone-100  hover:text-white mt-2 font-medium w-fit px-4 py-2 rounded-md "
                >
                  Entrar
                </Link>
              </li>
            </ul>
          }
        /> */}

            <CardService
              title={"Crea tu software con nosotros."}
              image={ImageDsf}
              list={
                <div className=" md:font-medium text-stone-400 text-xs">
                  Impulsa tu negocio, web, contenido digital y apps móviles.
                  <div
                    onClick={() => visitWhatsappExpert()}
                    className="opensans cursor-pointer bg-red-500  hover:bg-indigo-500 text-white mt-1 mx-auto font-semibold text-black w-fit px-2 py-2 rounded-md"
                  >
                    Hablar con un experto
                  </div>
                </div>
              }
            />

            <CardService
              title={"Recarga dólares P2P Deriv."}
              image={ImageP2p}
              list={
                <div className=" md:font-medium text-stone-400 text-xs">
                  <div>
                    Atención personalizada, precios bajos, bancos locales y
                    seguridad.
                  </div>

                  <div
                    onClick={() => visitWhatsapp()}
                    className="opensans cursor-pointer bg-red-500  hover:bg-indigo-500 text-white mt-1 mx-auto font-semibold   w-fit px-2 py-2 rounded-md"
                  >
                    Recargar
                  </div>
                </div>
              }
            />

            <CardService
              title={"Canal privado de trading"}
              image={ImageTradingChannel}
              list={
                <div className=" md:font-medium text-stone-400 text-xs">
                  Maximiza ganancias, protege tu inversión, gestión de riesgos y
                  asesoría.
                  <div className="my-4">
                    <Link
                      to="https://t.me/+yBpSO1oLEWo0MzBh"
                      target="_blank"
                      className="opensans bg-red-500  hover:bg-indigo-500 text-white mt-1 mx-auto hover:text-white font-semibold text-black w-fit px-2 py-2 rounded-md"
                    >
                      ¡Unirme!
                    </Link>
                  </div>
                </div>
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurServices;
